let mutations = {
    getProjects(state, payload) {
        state.all = payload;
    },
    setCachedProjects(state, payload) {
        state.cachedAll = payload;
    },
    getPersons(state, payload) {
        state.persons = payload;
    },
    setStatuses(state, payload) {
        state.statuses = payload;
    },
    getGroups(state, payload) {
        // @TODO: uncomment to pagination purposes
        // state.groups = {
        //     ...state.groups,
        //     ...payload
        // };

        state.groups = payload;
    },
    setGhostGroup(state, payload) {
        state.ghostGroup = payload;
    },
    setFullDayAbsences(state, payload) {
        state.fullDayAbsences = payload;
    },
    setPartDayAbsences(state, payload) {
        state.partDayAbsences = payload;
    },
    setWeekSchedules(state, payload) {
        state.weekSchedules = payload;
    },
    updated(state, payload) {
        state.updated = payload;
    },
    draggingGroup(state, payload) {
        state.draggingGroup = payload;
    },
    canBeManaged(state, payload) {
        state.canBeManaged = payload;
    }
};

export default mutations;